import { render, staticRenderFns } from "./page-job-company.vue?vue&type=template&id=775e55ec&"
import script from "./page-job-company.vue?vue&type=script&lang=js&"
export * from "./page-job-company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports